export default "__VITE_ASSET__B_67bJ69__"